module.exports = __webpack_public_path__ + "img/vertical_7_3_9006.2285a852.png";